import { render } from "./App.vue?vue&type=template&id=4de3476d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4de3476d&lang=css"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__